export default __webpack_public_path__ + "static/media/hand@2x.49740d64.png";